


























import Vue, { PropType } from "vue"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"

export default Vue.extend({
  components: {
    FilterDescription,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    options: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  methods: {
    isSelected(possibleOperationHours: number): boolean {
      return this.value.includes(possibleOperationHours)
    },
    handleInput(selectedPossibleOperationHours: number[]) {
      this.$emit("input", selectedPossibleOperationHours)
    },
    // 与えられた二つのオプションの間の選択肢を抽出するためのメソッド
    extractOptionInBetween(edgeOption1: number, edgeOption2: number): number[] {
      return edgeOption1 < edgeOption2
        ? this.options.filter(
            (option) => option >= edgeOption1 && option <= edgeOption2
          )
        : this.options.filter(
            (option) => option >= edgeOption2 && option <= edgeOption1
          )
    },
    select(possibleOperationHours: number) {
      // １つも選択されていない場合または複数選択されている場合は、今回選択されたものだけを選択した状態にする。
      if (this.value.length === 0 || this.value.length > 1) {
        this.handleInput([possibleOperationHours])
        return
      }

      // 1つのみ選択された状態で、その選択肢を選択した場合は、未選択状態にする。
      if (this.value.length === 1 && this.value[0] === possibleOperationHours) {
        this.handleInput([])
        return
      }

      // 1つのみ選択された状態で、それとは異なる選択肢を選択した場合は、その2つの間の選択肢を全て選択した状態にする。
      this.handleInput(
        this.extractOptionInBetween(possibleOperationHours, this.value[0])
      )
    },
  },
})
